import "./input.scss";
import React from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    icon: IconProp;
    label: string;
}

type State = {
    show: boolean;
};

export default class PasswordInput extends React.Component<Props, State> {
    public state = {
        show: false,
    };

    public onShow = (): void => {
        this.setState(prevState => ({
            show: !prevState.show,
        }));
    };

    public render(): React.ReactNode {
        const { icon, label, ...props } = this.props;

        return (
            <div className="form-input password-input">
                <div className="input-icon left">
                    <FontAwesomeLight icon={icon} />
                </div>
                <input
                    placeholder={label}
                    {...props}
                    type={this.state.show ? "text" : "password"}
                />
                <div
                    className={"input-icon right clickable show-toggle" + (this.state.show ? " show" : "")}
                    title="Click to toggle showing password"
                    onClick={this.onShow}
                    tabIndex={-1}
                >
                    <FontAwesomeLight icon={this.state.show ? "eye" : "eye-slash"} />
                </div>
            </div>
        );
    }
}
